import script from "./DishList.vue?vue&type=script&setup=true&lang=js"
export * from "./DishList.vue?vue&type=script&setup=true&lang=js"

import "./DishList.vue?vue&type=style&index=0&id=5b65bf21&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b65bf21"]])

export default __exports__